// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"dbfc7342","450":"de5788c8"}[chunkId] + ".chunk.js";
};